document.querySelectorAll('.add-to-wishlist').forEach( (button) => {
  const productCard = button.closest('.wishlist-product-card');
  const productJson = productCard.getAttribute('data-product-json');
  const productData = JSON.parse(productJson);
  const wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
  const existingProduct = wishlist.find((item) => item.id === productData.id);

  if (existingProduct) {
    button.classList.add('in-wishlist');
  }

  button.addEventListener('click', () => {
    var wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
    const existingIndex = wishlist.findIndex((item) => item.id === productData.id);

    if (existingIndex > -1) {
      wishlist.splice(existingIndex, 1);
      button.classList.remove('in-wishlist');
      showPopup('Item removed from wishlist!');
    } else {
      const product = {
        id: productData.id,
        title: productData.title,
        url: `/products/${productData.handle}`,
        images: productData.images,
        price: parseFloat(productData.variants[0].price / 100).toFixed(2),
        compareAtPrice: productData.variants[0].compare_at_price
          ? parseFloat(productData.variants[0].compare_at_price / 100).toFixed(2)
          : null,
      };
      wishlist.push(product);
      button.classList.add('in-wishlist');
      showPopup('Item added to wishlist!');
    }

    localStorage.setItem('wishlist', JSON.stringify(wishlist));

    if (window.location.pathname.includes('/pages/wishlist')) {
      displayWishlist();
    }
  });
});

function showPopup(message) {
  var popup = document.getElementById('wishlist-popup');
  if (!popup) {
    popup = document.createElement('div');
    popup.id = 'wishlist-popup';
    popup.style.position = 'fixed';
    popup.style.top = '50%';
    popup.style.right = '20px';
    popup.style.background = '#000';
    popup.style.color = 'white';
    popup.style.padding = '10px';
    popup.style.borderRadius = '5px';
    popup.style.zIndex = '1000';
    document.body.appendChild(popup);
  }
  popup.textContent = message;
  popup.style.display = 'block';
  setTimeout(() => {
    popup.style.display = 'none';
  }, 2000);
}

function displayWishlist() {
  const wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
  const wishlistContainer = document.getElementById('wishlist-container');
  const emptyContent = document.getElementById('empty-content');

  if (!wishlistContainer || !emptyContent) {
    console.error("Wishlist container or empty content element not found.");
    return;
  }

  wishlistContainer.innerHTML = '';

  if (wishlist.length === 0) {
    emptyContent.style.display = 'block';
    return;
  }

  emptyContent.style.display = 'none';

  wishlist.forEach((item) => {
    if (item && item.id) {
      const card = document.createElement('div');
      card.classList.add('wishlist-card');
      card.setAttribute('data-id', item.id);

      const imageSrc = item.images && item.images.length > 0 ? item.images[0] : '';

      var discountPercentage = null;
      if (item.compareAtPrice) {
        const discount = ((item.compareAtPrice - item.price) / item.compareAtPrice) * 100;
        discountPercentage = `${Math.round(discount)}% OFF`;
      }

      card.innerHTML = `
        <div class="wishlist-card-content">
          <a href="${item.url}">
            <img src="${imageSrc}" alt="${item.title}" class="wishlist-image">
            <div class="title-button-container">
              <h3>${item.title.replace(/\s*\(.*?\)/, '')}</h3>
              <button class="wishlistpage-removeitem">
                <svg class="fvrtfill" fill="#000000" width="20px" height="20px" viewBox="0 0 8 8" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 0v8l2-2 2 2v-8h-4z" transform="translate(2)" />
                </svg>
              </button>
            </div>
            <div class="price-container">
              ${
                item.compareAtPrice
                  ? `<span class="compare-price">PKR ${parseFloat(item.compareAtPrice)
                      .toFixed(2)
                      .replace(/\.00$/, '')}</span>`
                  : ''
              }
              <span class="${item.price == item.compareAtPrice ? 'price hidden' : 'price' }">
                PKR ${parseFloat(item.price)
                  .toFixed(2)
                  .replace(/\.00$/, '')}
                ${
                  discountPercentage
                    ? `<span class="discount-percentage">(${discountPercentage})</span>`
                    : ''
                }
              </span>
            </div>
          </a>
        </div>
      `;
      wishlistContainer.appendChild(card);
    }
  });

  wishlistContainer.querySelectorAll('.wishlistpage-removeitem').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      const card = button.closest('.wishlist-card');
      const productId = card.getAttribute('data-id');
      var wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];

      const updatedWishlist = wishlist.filter((item) => item.id != productId);
      localStorage.setItem('wishlist', JSON.stringify(updatedWishlist));
      location.reload();
    });
  });
}

if (window.location.pathname.includes('/pages/wishlist')) {
  displayWishlist();
}
